<template>
<div
  v-if="Array.isArray(nav.children) && nav.children.length > 0"
>
  <div :style="{'padding-left': `${deep}em`}" class="nav-link" @click="onNavNodeClick">
<!--    <i :class="nav.icon" class="nav-icon"></i>-->
    <span>{{nav.label}}</span>
    <i class="nav-item-arrow el-icon-arrow-down" :style="`transform:rotate(${visible * 180}deg)`"></i>
  </div>
  <layout-sub-nav ref="subNav" :sub-nav-list="nav.children" :deep="deep + 1" style="height:0;" />
</div>
<router-link
  v-else
  :to="{name: nav.name}"
  :style="{'padding-left': `${deep}em`}"
  class="nav-link"
>
<!--  <i :class="nav.icon" class="nav-icon"></i>-->
  <span>{{nav.label}}</span>
</router-link>
</template>

<script>
import BaseStore from '../BaseStore'

export default {
  name: 'SubNavItem',
  extends: BaseStore,
  props: {
    nav: {
      require: true,
      type: Object
    },
    deep: {
      type: Number,
      default: 1
    }
  },
  data () {
    let navName = this.nav.name

    return {
      visible: this.$route.matched.some(matched => matched.name === navName)
    }
  },
  methods: {
    onNavNodeClick () {
      this.getSubNav().changeHeight(this.visible = !this.visible)
    },
    getSubNav () {
      return this.$refs.subNav
    }
  },
  mounted () {
    if (this.visible) {
      let subNav = this.getSubNav()

      if (subNav) {
        subNav.changeHeightWithoutAnimation(true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-link {
  position: relative;
  display: block;
  transition: border-color .3s,background-color .3s,color .3s;
  cursor: pointer;

  &.router-link-active {
    /*color: #409eff;*/
    color: #ffffff;
    background: linear-gradient(to right, rgba(41, 56, 125, .95) 0%, transparent 100%);
  }

  &:hover {
    /*background-color: #ecf5ff;*/
    background: linear-gradient(to right, rgba(57, 69, 125, 0.95) 0%, transparent 100%);
  }

  > .nav-icon {
    width: 1em;
    margin-right: 10px;
    text-align: center;
  }

  > .nav-item-arrow {
    position: absolute;
    top: 0;
    right: 20px;
    bottom: 0;
    width: 1em;
    height: 1em;
    margin: auto 0;
    /*color: #909399;*/
    color: currentColor;
    transition: transform .3s;
  }
}

.sub-nav {
  overflow: hidden;
  transition: height .3s;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/SubNavItem.vue